import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-personal_def",
  "use": "icon-personal_def-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-personal_def\"><path d=\"M617.159787 918.813345L511.973132 1024l-105.186655-105.186655a465.427678 465.427678 0 1 1 210.37331 0zM232.716526 624.663053A347.674475 347.674475 0 0 0 519.419975 791.286161a348.605331 348.605331 0 0 0 285.772594-166.623108 418.88491 418.88491 0 0 0-572.476043 0zM511.973132 418.944019a139.628303 139.628303 0 1 0-139.628303-139.628303 139.628303 139.628303 0 0 0 139.628303 139.628303z\" p-id=\"1019\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/personal_def.svg
// module id = vQ1f
// module chunks = 44